import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check if the user is authenticated by looking for the 'userId' in sessionStorage.
  // This is the same check your Login.jsx component uses to store the user ID.
  const isAuthenticated = sessionStorage.getItem('userId');

  // If the user is authenticated, render the child components (the private route's content).
  // This is a common pattern to pass components as children.
  if (isAuthenticated) {
    return children;
  }

  // If the user is not authenticated, redirect them to the login page using Navigate.
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
